import { render, staticRenderFns } from "./ListParticipantsPaginated.vue?vue&type=template&id=440b920a&scoped=true&"
import script from "./ListParticipantsPaginated.vue?vue&type=script&lang=js&"
export * from "./ListParticipantsPaginated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440b920a",
  null
  
)

export default component.exports